import { useIsMobile } from '@findy-code/yuffie/utils/media-query';

import { LinkCard, LinkCardBody, useExpandableItems } from '../../../common';
import { SectionLayoutBase } from '../../../common/section-layout-base.component';
import type { FetchJobDescriptionDetailCompanyInterviewFragment } from '../../graphql';
import styles from './company-interviews.component.module.scss';

type Props = {
  interviews: FetchJobDescriptionDetailCompanyInterviewFragment[];
  onClick?: (label: string) => void;
};

// TODO: CompanyFindyToolsArticlesInnerと共通化
const CompanyInterviewsInner = ({ interviews, onClick }: Props) => (
  <ul className={styles.interviewList}>
    {interviews.map((interview, index) => (
      <li
        className={styles.interviewItem}
        data-single-item={interviews.length === 1}
        key={index}
      >
        <LinkCard
          body={
            <LinkCardBody
              publishedAt={interview.publishedAt}
              title={interview.title}
            />
          }
          href={`/pick-up/interviews/${interview.alias}`}
          thumbnailImage={
            // eslint-disable-next-line @next/next/no-img-element
            <img
              alt="インタビュー見出し"
              className={styles.interviewImage}
              height={interview.thumbnailUrl ? undefined : 175}
              src={
                interview.thumbnailUrl ||
                (process.env.NEXT_PUBLIC_YUFFIE_ENV === 'production'
                  ? `https://s3-ap-northeast-1.amazonaws.com/findy-code-images/interviews/${interview.alias}/top.jpg`
                  : '/images/lp/findy-share-interview.png')
              }
              width={interview.thumbnailUrl ? undefined : 303}
            />
          }
          onClick={() => {
            onClick?.(`求人計測_インタビュークリック_${index + 1}`);
          }}
        />
      </li>
    ))}
  </ul>
);

export const CompanyInterviews = ({ interviews, onClick }: Props) => {
  const isMobile = useIsMobile();
  const { displayItems, ExpandButton } = useExpandableItems(
    interviews,
    isMobile ? interviews.length : 3,
    '企業インタビュー記事をもっとみる'
  );
  return (
    <SectionLayoutBase
      heading={{ title: 'インタビュー' }}
      id="company-interview"
    >
      <CompanyInterviewsInner interviews={displayItems} onClick={onClick} />
      <ExpandButton />
    </SectionLayoutBase>
  );
};
